export const NAME = 'departments';